import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const FAQS = [{
  q: '¿Necesito experiencia previa para empezar?',
  a: 'No. El Tomo I está diseñado para quien empieza desde cero. Si ya tenés experiencia podés ir directo al nivel que corresponde.'
}, {
  q: '¿Tiene fecha de vencimiento?',
  a: 'No. Una vez que comprás el acceso es tuyo para siempre — incluyendo actualizaciones futuras sin costo adicional.'
}, {
  q: '¿En qué formato están los materiales?',
  a: 'Todo en PDF de alta calidad — compatible con cualquier dispositivo, tablet, celular o computadora.'
}, {
  q: '¿Puedo imprimir los materiales?',
  a: 'Sí. Los bonos están especialmente diseñados para imprimirse y usarlos junto a la camilla.'
}, {
  q: '¿La garantía aplica a las dos opciones?',
  a: 'Sí. Las dos opciones tienen garantía de 7 días completa sin preguntas ni burocracia.'
}, {
  q: '¿Recibo sintonización con el curso?',
  a: 'El sistema incluye el Tomo IV completo sobre sintonizaciones. Para recibir una sintonización personal consultanos por privado.'
}, {
  q: '¿Qué pasa si tengo dudas durante el estudio?',
  a: 'Podés escribirnos directamente. Respondemos todas las consultas relacionadas con el contenido del sistema.'
}, {
  q: '¿Las plantillas de Canva son editables?',
  a: 'Sí. Todas las plantillas del Kit Pro son 100% editables en Canva con tu nombre y tu marca.'
}];
export function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-137">
      <div className="container mx-auto max-w-3xl" data-id="element-138">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-139">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-140">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-141">
          {FAQS.map((faq, idx) => <div key={idx} className="bg-[#111111] rounded-xl border border-white/10 overflow-hidden transition-all duration-300" data-id="element-142">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-143">
                <span className="font-bold text-white pr-4" data-id="element-144">{faq.q}</span>
                <span className={`text-[#eab308] text-xl transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`} data-id="element-145">
                  +
                </span>
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-146">
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-147">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}